import React from 'react';
import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { reaction } from 'mobx';
import { IReactionDisposer } from 'mobx/lib/internal';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

@Feature()
export class TransitionDurationFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;
    public toolbarService: ToolbarService;
    public initReaction: IReactionDisposer;

    public constructor() {
        super();
        this.toolbarService = InjectorService.get(ToolbarService);

        this.initReaction = reaction(() => this.currentSlide, () => {
            this.toolbarService.$forceUpdate();
        });
    }

    public updateDuration = (val: number) => {
        if (val !== this.transitionDuration) {
            this.getTransitionService()?.then(((module) => {
                module.updateTransitionEffect({ duration: val });
            }));
        }
    };

    public getCustomDisabledState() {
        return !this.currentSlideTransition
            || this.currentSlideTransition?.type === TransitionType.EMPTY;
    }

    public get transitionDuration() {
        return this.currentSlideTransition?.property?.duration || 0;
    }

    public get currentSlideTransition() {
        return this.currentSlide?.transition;
    }

    private get currentSlide() {
        return this.getAppService().viewableServiceLayer.selectionService.currentSlide;
    }

    private getTransitionService() {
        return this.getAppService().editableServiceLayer?.transitionService?.promise();
    }
}
